import { render, staticRenderFns } from "./FormEstablishment.vue?vue&type=template&id=5bff7381&scoped=true"
import script from "./FormEstablishment.vue?vue&type=script&lang=js"
export * from "./FormEstablishment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff7381",
  null
  
)

export default component.exports